module.exports = __webpack_public_path__ + "img/document.53396f35.svg";